__turbopack_context__.v({
  "actions": "page-module__ZmaE7q__actions",
  "archiveLink": "page-module__ZmaE7q__archiveLink",
  "atmosphere": "page-module__ZmaE7q__atmosphere",
  "availability": "page-module__ZmaE7q__availability",
  "availabilityCopy": "page-module__ZmaE7q__availabilityCopy",
  "block": "page-module__ZmaE7q__block",
  "composition": "page-module__ZmaE7q__composition",
  "dossier": "page-module__ZmaE7q__dossier",
  "heading": "page-module__ZmaE7q__heading",
  "headingIndex": "page-module__ZmaE7q__headingIndex",
  "lede": "page-module__ZmaE7q__lede",
  "ledger": "page-module__ZmaE7q__ledger",
  "masthead": "page-module__ZmaE7q__masthead",
  "mastheadIntro": "page-module__ZmaE7q__mastheadIntro",
  "materialDesc": "page-module__ZmaE7q__materialDesc",
  "materialRow": "page-module__ZmaE7q__materialRow",
  "materialTerm": "page-module__ZmaE7q__materialTerm",
  "materials": "page-module__ZmaE7q__materials",
  "motion": "page-module__ZmaE7q__motion",
  "note": "page-module__ZmaE7q__note",
  "noteArabic": "page-module__ZmaE7q__noteArabic",
  "noteFill": "page-module__ZmaE7q__noteFill",
  "noteMl": "page-module__ZmaE7q__noteMl",
  "noteName": "page-module__ZmaE7q__noteName",
  "notePercent": "page-module__ZmaE7q__notePercent",
  "noteTrack": "page-module__ZmaE7q__noteTrack",
  "numeral": "page-module__ZmaE7q__numeral",
  "plate": "page-module__ZmaE7q__plate",
  "plate-breath": "page-module__ZmaE7q__plate-breath",
  "plate-refraction": "page-module__ZmaE7q__plate-refraction",
  "plateAura": "page-module__ZmaE7q__plateAura",
  "plateCaption": "page-module__ZmaE7q__plateCaption",
  "plateColumn": "page-module__ZmaE7q__plateColumn",
  "plateProduct": "page-module__ZmaE7q__plateProduct",
  "plateRefraction": "page-module__ZmaE7q__plateRefraction",
  "record": "page-module__ZmaE7q__record",
  "recordKey": "page-module__ZmaE7q__recordKey",
  "recordRow": "page-module__ZmaE7q__recordRow",
  "recordValue": "page-module__ZmaE7q__recordValue",
  "reliquary": "page-module__ZmaE7q__reliquary",
  "subtitle": "page-module__ZmaE7q__subtitle",
  "title": "page-module__ZmaE7q__title",
  "turntable": "page-module__ZmaE7q__turntable",
  "turntableCanvas": "page-module__ZmaE7q__turntableCanvas",
  "turntableCaption": "page-module__ZmaE7q__turntableCaption",
  "turntableControl": "page-module__ZmaE7q__turntableControl",
  "turntableControlIndex": "page-module__ZmaE7q__turntableControlIndex",
  "turntableControls": "page-module__ZmaE7q__turntableControls",
  "turntableFrame": "page-module__ZmaE7q__turntableFrame",
  "turntableHint": "page-module__ZmaE7q__turntableHint",
  "turntableMedia": "page-module__ZmaE7q__turntableMedia",
  "turntableStage": "page-module__ZmaE7q__turntableStage",
  "turntableSurface": "page-module__ZmaE7q__turntableSurface",
});
